import { Box, Stack, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import useAuth from '@/hooks/useAuth'

const options = [
    {
        label: 'Compact',
        value: false,
        icon: (
            <Box
                sx={{
                    backgroundColor: 'background.paper',
                    flex: '1 1 auto',
                    p: 1
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gap: 0.5,
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        height: '100%',
                        mx: 'auto',
                        width: '70%'
                    }}
                >
                    <Box
                        sx={(theme) => ({
                            backgroundColor: 'background.paper',
                            borderColor: 'neutral.700',
                            borderRadius: 1,
                            borderStyle: 'dashed',
                            borderWidth: 1,
                            ...theme.applyStyles('dark', {
                                borderColor: 'neutral.500'
                            })
                        })}
                    />
                    <Box
                        sx={(theme) => ({
                            backgroundColor: 'background.paper',
                            borderColor: 'neutral.700',
                            borderRadius: 1,
                            borderStyle: 'dashed',
                            borderWidth: 1,
                            ...theme.applyStyles('dark', {
                                borderColor: 'neutral.500'
                            })
                        })}
                    />
                </Box>
            </Box>
        )
    },
    {
        label: 'Wide',
        value: true,
        icon: (
            <Box
                sx={{
                    backgroundColor: 'background.paper',
                    flex: '1 1 auto',
                    p: 1
                }}
            >
                <Box
                    sx={{
                        display: 'grid',
                        gap: 0.5,
                        gridTemplateColumns: 'repeat(2, 1fr)',
                        height: '100%',
                        mx: 'auto'
                    }}
                >
                    <Box
                        sx={(theme) => ({
                            backgroundColor: 'background.paper',
                            borderColor: 'neutral.800',
                            borderRadius: 1,
                            borderStyle: 'dashed',
                            borderWidth: 1,
                            ...theme.applyStyles('dark', {
                                borderColor: 'neutral.500'
                            })
                        })}
                    />
                    <Box
                        sx={(theme) => ({
                            backgroundColor: 'background.paper',
                            borderColor: 'neutral.700',
                            borderRadius: 1,
                            borderStyle: 'dashed',
                            borderWidth: 1,
                            ...theme.applyStyles('dark', {
                                borderColor: 'neutral.500'
                            })
                        })}
                    />
                </Box>
            </Box>
        )
    }
]

export const OptionsStretch = (props) => {
    const { onChange, value } = props
    const { settings } = useAuth()

    return (
        <Stack spacing={1}>
            <Typography
                color="text.secondary"
                variant="overline"
                sx={{ mt: 4 }}
            >
                Content
            </Typography>
            <Box
                sx={{
                    gap: 1,
                    display: 'grid',
                    gridTemplateColumns: 'repeat(2, minmax(0, 140px))'
                }}
            >
                {options.map((option, index) => (
                    <Stack
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        spacing={1}
                    >
                        <Box
                            onClick={() => onChange?.(option.value)}
                            sx={[
                                {
                                    borderColor: 'divider',
                                    borderRadius: settings.style.roundedCorners
                                        ? 1
                                        : 0,
                                    borderStyle: 'solid',
                                    borderWidth: 2,
                                    cursor: 'pointer',
                                    display: 'flex',
                                    height: 64,
                                    overflow: 'hidden'
                                },
                                option.value === value && {
                                    borderColor: 'primary.main'
                                }
                            ]}
                        >
                            {option.icon}
                        </Box>
                        <Typography
                            align="center"
                            sx={{ fontWight: 500 }}
                            variant="body2"
                        >
                            {option.label}
                        </Typography>
                    </Stack>
                ))}
            </Box>
        </Stack>
    )
}

OptionsStretch.propTypes = {
    onChange: PropTypes.func,
    value: PropTypes.bool
}
